import { FC } from 'react';

import MuiTableCell, { TableCellProps } from '@mui/material/TableCell';

type Props = TableCellProps & {
  center?: boolean;
  right?: boolean;
};

const TableCell: FC<Props> = props => {
  const { children, center, right, sx = [], ...rest } = props;

  return (
    <MuiTableCell
      sx={[
        center && {
          textAlign: 'center',
        },
        right && {
          textAlign: 'right',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...rest}>
      {children}
    </MuiTableCell>
  );
};

export default TableCell;
